export default __webpack_public_path__ + "static/media/testo-2.8c4c6cbe.jpg";